import { useEffect, useState } from "react";
import { toast } from "sonner";
import { FileSpreadsheet, FileText, Users, IdCard, ClipboardCheck, ShieldCheck } from "lucide-react";
import { api, errMsg, downloadFile } from "@/lib/api";
import { useAuth } from "@/context/AuthContext";
import { PageHeader, NativeSelect } from "@/components/common";
import { Button } from "@/components/ui/button";

const DATASETS = [
  { key: "athletes", title: "Anagrafica atleti", desc: "Dati anagrafici e stato del tesseramento.", icon: Users, roles: ["admin", "sector_manager"] },
  { key: "licenses", title: "Licenze sportive", desc: "Numeri, categorie, validità e stato.", icon: IdCard, roles: ["admin", "sector_manager"] },
  { key: "participations", title: "Partecipazioni", desc: "Atleti registrati alle manifestazioni.", icon: ClipboardCheck, roles: ["admin", "sector_manager", "organizer"], byEvent: true },
  { key: "verifications", title: "Registro verifiche", desc: "Tutte le scansioni con esito e motivazione.", icon: ShieldCheck, roles: ["admin", "sector_manager", "organizer"], byEvent: true },
];

export default function Reports() {
  const { user } = useAuth();
  const [events, setEvents] = useState([]);
  const [eventId, setEventId] = useState("");
  useEffect(() => { api.get("/events").then((r) => setEvents(r.data)); }, []);
  const dl = (ds, fmt, byEvent) => downloadFile(`/reports/export?dataset=${ds}&fmt=${fmt}${byEvent ? `&event_id=${eventId}` : ""}`, `msp-${ds}.${fmt}`)
    .then(() => toast.success("Esportazione completata")).catch((e) => toast.error(errMsg(e)));

  return (
    <div>
      <PageHeader eyebrow="Esportazioni" title="Report" subtitle="Esporta i dati in Excel o CSV. Ogni esportazione è registrata nel log delle operazioni." />
      <div className="mb-6 max-w-md">
        <div className="mb-1.5 text-sm font-medium text-slate-700">Filtra partecipazioni e verifiche per manifestazione</div>
        <NativeSelect value={eventId} onChange={setEventId} className="w-full" testid="reports-event-filter">
          <option value="">Tutte le manifestazioni accessibili</option>
          {events.map((e) => <option key={e.id} value={e.id}>{e.name}</option>)}
        </NativeSelect>
      </div>
      <div className="grid gap-4 md:grid-cols-2">
        {DATASETS.filter((d) => d.roles.includes(user.role)).map((d) => (
          <div key={d.key} className="card-surface flex items-start gap-4 p-5" data-testid={`report-card-${d.key}`}>
            <div className="rounded-xl bg-blue-50 p-3 text-[#1E3A8A]"><d.icon className="h-6 w-6" /></div>
            <div className="flex-1">
              <div className="font-display text-lg font-semibold">{d.title}</div>
              <div className="text-sm text-slate-600">{d.desc}</div>
              <div className="mt-4 flex gap-2">
                <Button size="sm" onClick={() => dl(d.key, "xlsx", d.byEvent)} className="bg-emerald-700 hover:bg-emerald-800" data-testid={`report-${d.key}-xlsx-btn`}><FileSpreadsheet className="mr-1.5 h-4 w-4" />Excel</Button>
                <Button size="sm" variant="outline" onClick={() => dl(d.key, "csv", d.byEvent)} data-testid={`report-${d.key}-csv-btn`}><FileText className="mr-1.5 h-4 w-4" />CSV</Button>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
